<template>
<!-- eslint-disable max-len -->
<div class="team">
  <template v-for="(player, i) in currentOtherPlayers">
    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutUp" :key="`player-${i}`">
      <div v-if="showPlayer && !animateOut" class="player" :style="playerStyle(player, i)" @click="proxyRole(player)">
        <div class="player-icon">
          <transition v-if="player.character != null" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <img v-if="!player.decision" class="player-icon-img" :src="resolveAssetPath(player.character.icon, 'characters')" key="icon">
            <img v-else-if="player.groupDecision.completed || teamDecisionProgressed" class="player-icon-img" :src="resolveAssetPath(player.character.iconUndecided, 'characters')" key="iconBlack">
            <img v-else class="player-icon-img" :src="resolveAssetPath(player.character.iconDecided, 'characters')" key="iconWhite">
          </transition>
        </div>
        <template v-if="player.decision">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <p v-if="showStatus && (player.groupDecision.completed || teamDecisionProgressed)" class="decision-complete">I have made my decision!</p>
          </transition>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <p v-if="showStatus && !player.groupDecision.completed && !teamDecisionProgressed" class="decision-incomplete">Still thinking about my decision...</p>
          </transition>
        </template>
        <template v-else-if="player.fakeResponse">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <p v-if="showStatus[i] && currentState === resultsState" class="decision-complete">{{ player.fakeResponse.toUpperCase() }}</p>
          </transition>
        </template>
        <p class="player-icon-label">{{ `${player.character != null ? player.character.title : ''}${(player.character != null && player.role.title) ? ': ' : ''}${player.role.title && `${player.role.title}` || ''}` }}</p>
      </div>
    </transition>
  </template>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    animateOut: { type: Boolean },
    showLast: { type: Boolean }
  },
  data() {
    return {
      showPlayer: false,
      showStatus: [false, false, false, false],
      currentGroupTeamDecision: {},
      lockProxyRole: false
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'groupTeamDecision',
      'otherPlayers',
      'playerNextDecision',
      'me',
      'lastGroupTeamDecision',
      'lastOtherPlayers',
      'fakeOtherPlayers',
      'currentState',
      'resultsState'
    ]),
    fakePlayerBackgrounds() {
      const bgs = [];

      console.log(this.activeEnvironment);

      if (this.activeEnvironment && this.activeEnvironment.defaultTeamBanner1) {
        bgs.push(this.activeEnvironment.defaultTeamBanner1);
      } else {
        bgs.push('https://assets.redmeru.com/master/Providence/TM_Banner_CallCenter02.jpg');
      }

      if (this.activeEnvironment && this.activeEnvironment.defaultTeamBanner2) {
        bgs.push(this.activeEnvironment.defaultTeamBanner2);
      } else {
        bgs.push('https://assets.redmeru.com/master/Providence/TM_Banner_Office02.jpg');
      }

      if (this.activeEnvironment && this.activeEnvironment.defaultTeamBanner3) {
        bgs.push(this.activeEnvironment.defaultTeamBanner3);
      } else {
        bgs.push('https://assets.redmeru.com/master/Providence/TM_Banner_ServerRoom01.jpg');
      }

      if (this.activeEnvironment && this.activeEnvironment.defaultTeamBanner4) {
        bgs.push(this.activeEnvironment.defaultTeamBanner4);
      } else {
        bgs.push('https://assets.redmeru.com/master/Providence/TM_Banner_FinanceOffice.jpg');
      }

      console.log(bgs);
      return bgs;
    },
    teamDecisionProgressed() {
      return this.groupTeamDecision._id !== this.currentGroupTeamDecision._id;
    },
    currentOtherPlayers() {
      if (this.otherPlayers.length === 0) return this.fakeOtherPlayers;
      if (this.showLast || this.teamDecisionProgressed) {
        return this.lastOtherPlayers;
      }
      return this.otherPlayers;
    }
  },
  methods: {
    ...mapActions([
      'submitChoice',
      'submitAllocation',
      'setProxyRole',
      'resetProxyRole'
    ]),
    async proxyRole({ decision, groupRole: { _id, player, playedBy } = {} }) {
      if (this.playerNextDecision) return;
      if (!decision) return;
      if (this.lockProxyRole) return;
      this.lockProxyRole = true;

      if (player === this.me._id) this.resetProxyRole();
      else if (playedBy === this.me._id) this.setProxyRole({ _id });
      await Vue.nextTick();
      this.lockProxyRole = false;
    },
    playerStyle({ role, decision, groupDecision, fake }, index) {
      return {
        'background-image': fake ? `url(${this.resolveAssetPath(this.fakePlayerBackgrounds[index], 'backgrounds')})` : role && role.backgroundBanner ? `url(${this.resolveAssetPath(role.backgroundBanner, 'backgrounds')})` : 'none',
        'border-color': !decision || this.teamDecisionProgressed || (groupDecision && groupDecision.completed) ? 'white' : 'black',
        'animation-delay': `${(index * 0.06)}s`
      };
    },
    async fakeResponseShow() {
      for (let i = 0; i < this.showStatus.length; i++) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        await Vue.set(this.showStatus, i, true);
      }
    }
  },
  created() {
    this.currentGroupTeamDecision =
      this.showLast ? this.lastGroupTeamDecision : this.groupTeamDecision;
  },
  async mounted() {
    await new Promise(resolve => setTimeout(resolve, 500));
    this.showPlayer = true;

    await this.fakeResponseShow();
  }
};
</script>

<style lang="scss" scoped>
.fadeInUp {
  animation-duration: 0.8s;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}
.fadeOutUp {
  animation-duration: 0.4s;
  animation-timing-function: cubic-bezier(0.895, 0.03, 0.685, 0.22);
}

.team {
  width: 780px;
  height: 700px;
  padding: 10px;
  background-color: transparent;
  overflow-x: hidden;
  overflow-y: hidden; /* change to scroll if adjusting num roles */
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.player {
  width: 100%;
  height: 150px;
  background-repeat: no-repeat;
  background-size: cover;
  border: 4px solid var(--primaryColor);
  margin-bottom: 12px;
  position: relative;
  box-shadow: 0 0 10px 1px black;
  transition: border-color 1s;
  border-radius: 5px;
}
.player:last-of-type {
  margin-bottom: 0;
}
.player-icon {
  height: 142px;
  width: 272px;
  float: right;
  position: relative;
  padding: 0 80px;
}
.player-odd .player-icon {
  float: left;
}
.player-icon-img {
  height: 100%;
  position: relative;
}
.player-icon-label {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 200px;
  background-color: white;
  color: var(--primaryColor);
  margin: 5px 20px 5px 5px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 3px -3px 0px 0px var(--primaryColor);
}
.decision-complete {
  position: absolute;
  background-color: white;
  color: black;
  border: 4px solid black;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  padding: 15px 50px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 25px;
  width: 420px;
  margin: 0 0 0 50px;
}
/*
.player-odd .decision-complete {
  right: 50px;
}
*/
.decision-complete::before {
  position: absolute;
  top: 40%;
  right: -64px;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 16px 0 16px 64px;
  border-color: transparent transparent transparent black;
}
.player-odd .decision-complete::before {
  left: -64px;
  border-width: 16px 64px 16px 0;
  border-color: transparent black transparent transparent;
}
.decision-complete::after {
  position: absolute;
  top: 41%;
  right: -48px;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 14px 0 14px 56px;
  border-color: transparent transparent transparent white;
}
.player-odd .decision-complete::after {
  left: -48px;
  border-width: 14px 56px 14px 0;
  border-color: transparent white transparent transparent;
}
.decision-incomplete {
  position: absolute;
  background-color: #dddddd;
  color: #666666;
  border: 4px solid #dddddd;
  border-radius: 20px;
  font-size: 23px;
  font-weight: bold;
  padding: 15px 40px;
  top: 25px;
  margin: 0 0 0 50px;
}
.player-odd .decision-incomplete {
  left: 240px;
}
.decision-incomplete::before {
  content: '';
  position: absolute;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  right: -50px;
  top: 20px;
  background-color: #dddddd;
}
.player-odd .decision-incomplete::before {
  left: -50px;
}
.decision-incomplete::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  right: -80px;
  top: 15px;
  background-color: #dddddd;
}
.player-odd .decision-incomplete::after {
  left: -80px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Team.vue